import { Component, OnInit, Output, EventEmitter, Inject, inject } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { changesLayout } from 'src/app/store/layouts/layout.actions';
import { getLayoutMode } from 'src/app/store/layouts/layout.selector';
import { RootReducerState } from 'src/app/store';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SimplebarAngularModule } from 'simplebar-angular';
import { User } from 'firebase/auth'; // ✅ Modular Firebase SDK type

import { 
  Firestore,
  collection,
  collectionData,
  query,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  DocumentData,
  getDoc,
  addDoc,
  deleteDoc,
  onSnapshot
} from '@angular/fire/firestore';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, BsDropdownModule, SimplebarAngularModule],
})
export class TopbarComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private firestore = inject(Firestore);
  mode: any;
  element: any;
  cookieValue: any;
  flagvalue: any;
  countryName: any;
  valueset: any;
  theme: any;
  layout: string;
  dataLayout$: Observable<string>;
  user$: Observable<User | null>; // ✅ Modular type

  eventId: string | null = null;
  eventData: any = null;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  listLang: any[] = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  openMobileMenu: boolean;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService,
    public store: Store<RootReducerState>
  ) {
    this.user$ = this.authService.user$;
  }

  ngOnInit() {
    const refreshEvent = () => {
      const eventIdFromPath = this._getEventIdFromRouter();
      const eventIdFromQuery = this.router.routerState.snapshot.root.queryParamMap.get('eventId');
      const nextEventId = eventIdFromPath ?? eventIdFromQuery;

      if (nextEventId && nextEventId !== this.eventId) {
        this.eventId = nextEventId;
        this.loadEvent(this.eventId);
      }
    };

    refreshEvent();
    this.router.events.forEach(event => {
      if (event instanceof NavigationEnd) refreshEvent();
    });
  
    this.store.select('layout').subscribe((data) => {
      this.theme = data.DATA_LAYOUT;
    });

    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
  }

  private _getEventIdFromRouter(): string | null {
    let current = this.router.routerState.snapshot.root;
    while (current) {
      const eventId = current.paramMap.get('eventId');
      if (eventId) return eventId;
      current = current.firstChild as any;
    }
    return null;
  }

  async loadEvent(eventId: string) {
    const ref = doc(this.firestore, `events/${eventId}`);
    const snapshot = await getDoc(ref);
    if (snapshot.exists()) {
      this.eventData = snapshot.data();
      console.log('Event data:', this.eventData);
    } else {
      console.warn('Event not found');
    }
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout().subscribe(() => {
        this.router.navigate(['/auth/login']);
      });
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/auth/login']);
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      }
    }
  }

  changeLayout(layoutMode: string) {
    this.theme = layoutMode;
    this.store.dispatch(changesLayout({ layoutMode }));
    this.store.select(getLayoutMode).subscribe((layout) => {
      document.documentElement.setAttribute('data-layout', layout);
    });
  }
}
